import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextField, Button, Typography, Box, Container } from '@mui/material';
import axios from 'axios';
import NotFoundPage from '../../Pages/NotFoundPage';
import { isUser } from '../../Config/isUser';
import { isCompany } from '../../Config/isCompany';

const SetPassword = () => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [user, setUser] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUser = async () => {
      setLoading2(true);
      let url;
      url = isUser ? "https://kariyer.biyomed.net/api/users/getOne" : isCompany && "https://kariyer.biyomed.net/api/companies/getOne" // check if company
      try {
        const response = await axios.get(url, {
          withCredentials: true, // Cookie gönderimi için
        });
        if(isUser){
          setUser(response.data.user)
        }
        if(isCompany){
          setUser(response.data.company)
        }
      } catch (error) {
        console.error("Error fetching user:", error);
      }
      finally{
        setLoading2(false)
      }
    };

    fetchUser();
  }, []);  
  
  const handleSubmit = async () => {
    setError('');
    setSuccess(false);

    if (newPassword !== confirmPassword) {
      setError('Yeni şifreler eşleşmiyor');
      return;
    }
    if (newPassword.length < 6) {
      setError('Şifre en az 6 karakter olmalıdır');
      return;
    }

    try {
      let url;
      url= user.type === "user" ? 'https://kariyer.biyomed.net/api/user/setPassword' : isCompany && 'https://kariyer.biyomed.net/api/company/setPassword'
      
      setLoading(true);
      await axios.post(url, { newPassword }, { withCredentials: true });
      setSuccess(true);
      localStorage.setItem('first', '0'); // Şifre güncellendi, first değerini 0 yap
      if(user.type === "user"){
        navigate("/user-details")
      }
      if(user.type ==="company"){
        navigate("/company-details")
      }

    } catch (err) {
      setError(err.response?.data || 'Şifre güncelleme sırasında bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  return (<>
    {loading2 ? <div style={{ marginBottom: 100, marginTop: 200, justifyItems: "center" }}>
                 <p style={{ fontSize: "50px" }}>Yükleniyor Lütfen Bekleyniz </p>
               </div>: user.isFirstLogin === 1 || user.isFirstLogin === 2 ?
      <Container component="main" maxWidth="xs">
        <Box sx={{pb:20, pt:30}}>
          <Typography sx={{ ml: 13 }} variant="h5">
            Yeni Şifre Belirle
          </Typography>
          {success ? (
            <Typography color="green" sx={{ mt: 2 }}>
              Şifreniz başarıyla güncellendi!
            </Typography>
          ) : (
            <Box sx={{ marginTop: 5, mb: 5 }}>
              <TextField
                label="Yeni Şifre"
                variant="outlined"
                fullWidth
                margin="normal"
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <TextField
                label="Yeni Şifreyi Tekrar Girin"
                variant="outlined"
                fullWidth
                margin="normal"
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              {error && <Typography color="error">{error}</Typography>}
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={handleSubmit}
                disabled={loading}
                sx={{ marginTop: 2 }}
              >
                {loading ? 'Güncelleniyor...' : 'ŞİFREYİ GÜNCELLE '}
              </Button>
            </Box>
          )}
        </Box>
      </Container> : <NotFoundPage />}
  </>


  );
};

export default SetPassword;
